import React from 'react';
import clsx from 'clsx';
import { useT } from './i18n';

const APP_STORE_URL = 'https://apps.apple.com/sk/app/effzone/id6747626666';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=scan.sbs.app';
const APP_STORE_BADGE = '/assets/app_store.png';
const GOOGLE_PLAY_BADGE = '/assets/google_play.png';

const LandingStoreBadges = ({ label, divider = false, centered = false, className }) => {
  const t = useT();
  return (
  <div
    className={clsx(
      'landing-store-badges',
      divider && 'landing-store-badges--divider',
      centered && 'landing-store-badges--centered',
      className
    )}
  >
    {label && <p className="landing-store-badges__label">{label}</p>}
    <div className="landing-store-badges__row">
      <a href={APP_STORE_URL} aria-label={t('storeBadges.appStore')}>
        <img src={APP_STORE_BADGE} alt={t('storeBadges.appStore')} className="landing-store-badges__img" />
      </a>
      <a href={PLAY_STORE_URL} aria-label={t('storeBadges.googlePlay')}>
        <img src={GOOGLE_PLAY_BADGE} alt={t('storeBadges.googlePlay')} className="landing-store-badges__img" />
      </a>
    </div>
  </div>
  );
};

export default LandingStoreBadges;
